import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Calendar, Clock } from 'lucide-react';

export type PeriodFilterType = 'today' | 'week' | 'month' | 'all';

interface PeriodFilterProps {
  value: PeriodFilterType;
  onChange: (value: PeriodFilterType) => void;
  showIcon?: boolean;
}

export const PeriodFilter: React.FC<PeriodFilterProps> = ({ 
  value, 
  onChange, 
  showIcon = true 
}) => {
  return (
    <div className="flex items-center gap-2" role="group" aria-label="Filtre de période">
      {showIcon && <Calendar className="w-4 h-4 text-muted-foreground" aria-hidden="true" />}
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[140px]" aria-label="Sélectionner une période">
          <SelectValue placeholder="Période" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="today">Aujourd'hui</SelectItem>
          <SelectItem value="week">Cette semaine</SelectItem>
          <SelectItem value="month">Ce mois</SelectItem>
          <SelectItem value="all">Toute la période</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export const getDateRangeFromPeriod = (period: PeriodFilterType): { start: Date; end: Date } => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  switch (period) {
    case 'today':
      return {
        start: today,
        end: new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1)
      };
    
    case 'week':
      const weekStart = new Date(today);
      const dayOfWeek = today.getDay();
      // Calculer le lundi de cette semaine (si dimanche = 0, alors -6 jours, sinon -(dayOfWeek-1) jours)
      const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      weekStart.setDate(today.getDate() - daysToSubtract);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6); // Dimanche
      weekEnd.setHours(23, 59, 59, 999);
      return { start: weekStart, end: weekEnd };
    
    case 'month':
      const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      monthEnd.setHours(23, 59, 59, 999);
      return { start: monthStart, end: monthEnd };
    
    case 'all':
    default:
      return {
        start: new Date(2020, 0, 1), // Date très ancienne
        end: new Date(2030, 11, 31) // Date très future
      };
  }
};